'use client';

import { logoCardsGridSection } from '@stereoagency/sanity-schema';
import { ProjectLogoCardsSection } from '@stereoagency/ui';
import flush from 'just-flush';
import { SimpleBlockContent } from '../sanity/client';
import { linkAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof logoCardsGridSection.schema.logoCardsGridSection;

export default function LogoCardsGridSection({
  title,
  description,
  cards
}: Props) {
  if (!cards?.length) {
    return null;
  }

  return (
    <ProjectLogoCardsSection
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
      cards={flush(
        cards.map((card) => {
          if (!card.logo?.asset._ref || !card.title || !card.action) {
            return null;
          }

          return {
            logo: sanityImageAsProps(card.logo),
            title: card.title,
            action: {
              ...linkAsProps(card.action),
              label: card.label
            }
          };
        })
      )}
    />
  );
}
